var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 517.4 516.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    width: 635,
    height: 643,
    transform: "translate(30.2 -63.2) scale(.8)",
    xlinkHref: "icon-rent-1.png"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.4,360.8c-4.1-47.2-40.2-67.3-40.2-67.3l-7.7-17.1c-14.8-50.2-28.9-52-28.9-52-37.8-7.8-99.8-7.7-99.8-7.7,0,0-62-.1-99.8,7.7,0,0-14.2,1.8-28.9,52l-7.7,17.1s-36,20.1-40.2,67.3c0,0-20.6,4.4-19.4,64.2.1,6.3,1.2,12.5,3.5,18.3,2.8,7.2,7.7,15,15.9,15.6h353.2c8.2-.6,13.1-8.4,15.9-15.6,2.3-5.8,3.4-12,3.5-18.3,1.3-59.7-19.4-64.2-19.4-64.2Z",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.4,293.5s63.2,21.7,136.9,20.9",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.8,293.5s-63.9,21.7-137.5,20.9",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,408.7l60.6,13.7c3.6.7,7,2,10.1,4,4.4,2.8,9,7.5,8.8,14.7v42.1s0,.3,0,.9c-1.2,9-9,15.6-18.1,15.6h-33.8s-8.5.3-11.7-10.7-1-4.7-1-7.1v-23.2",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.5,409.3l-63.2,13.2c-3.6.7-7,2-10.1,4-4.4,2.8-9,7.5-8.8,14.7v42.1s0,.3,0,.9c1.2,9,9,15.6,18.1,15.6h33.8s8.5.3,11.7-10.7c.7-2.3,1-4.7,1-7.1v-23.2",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,458.9h-113.8c-8,0-13-5.3-14.5-13.6l-14.2-47.3c-2.5-8.2,3.4-16.8,12.3-17.4.3,0,.7,0,1,0h144.2c.3,0,.7,0,1,0,8.9.6,14.8,9.1,12.4,17.3l-13.9,47.4c-2.9,8.2-6.5,13.6-14.5,13.6Z",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 261.2,
    width: 55.1,
    height: 35.5,
    rx: 9,
    ry: 9,
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.2,
    y: 261.2,
    width: 55.1,
    height: 35.5,
    rx: 9,
    ry: 9,
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9,327.2l70,23.9c1.8.6,2.6,2.7,1.6,4.4s0,.1-.1.2c-10.8,18-32.8,25.6-52.6,18.7s-16.4-6.4-27.4-12.3",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.5,327.2l-70,23.9c-1.8.6-2.6,2.7-1.6,4.4s0,.1.1.2c10.8,18,32.8,25.6,52.6,18.7,7.3-2.5,16.4-6.4,27.4-12.3",
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 464,
    width: 81.5,
    height: 35.8,
    rx: 2,
    ry: 2,
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.2,
    y: 13.6,
    width: 33.1,
    height: 450.4,
    rx: 3.8,
    ry: 3.8,
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2,
    y: 30.5,
    width: 261.4,
    height: 113,
    rx: 5.6,
    ry: 5.6,
    fill: "none",
    stroke: "#0b0b0b",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(90.2 112.5) scale(1.1 1)",
    fill: "#231f20",
    fontFamily: "Arial-Black, Arial",
    fontSize: 67.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RENT")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentalIcon);
export default __webpack_public_path__ + "static/media/rental-icon.bd8353350a6d8b8c0bfeeaa795c9d400.svg";
export { ForwardRef as ReactComponent };